import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const QuickActionCards = ({ stats }) => {
  const actionCards = [
    {
      title: 'Recent Orders',
      value: stats.recentOrders,
      subtitle: 'Last 30 days',
      icon: 'Package',
      link: '/order-history',
      color: 'bg-blue-50 text-blue-600',
      iconBg: 'bg-blue-100'
    },
    {
      title: 'Wishlist Items',
      value: stats.wishlistCount,
      subtitle: 'Saved products',
      icon: 'Heart',
      link: '/wishlist',
      color: 'bg-red-50 text-red-600',
      iconBg: 'bg-red-100'
    },
    {
      title: 'Saved Addresses',
      value: stats.savedAddresses,
      subtitle: 'Delivery locations',
      icon: 'MapPin',
      link: '/addresses',
      color: 'bg-green-50 text-green-600',
      iconBg: 'bg-green-100'
    },
    {
      title: 'Account Settings',
      value: stats.profileCompletion + '%',
      subtitle: 'Profile complete',
      icon: 'Settings',
      link: '/settings',
      color: 'bg-purple-50 text-purple-600',
      iconBg: 'bg-purple-100'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {actionCards.map((card, index) => (
        <Link
          key={index}
          to={card.link}
          className="bg-card border border-border rounded-lg p-4 hover:shadow-elevation-1 transition-all duration-200 hover-scale group"
        >
          <div className="flex items-center justify-between mb-3">
            <div className={`w-10 h-10 rounded-lg ${card.iconBg} flex items-center justify-center`}>
              <Icon name={card.icon} size={20} className={card.color.split(' ')[1]} />
            </div>
            <Icon name="ArrowRight" size={16} className="text-muted-foreground group-hover:text-foreground transition-colors" />
          </div>
          <div>
            <p className="text-2xl font-bold text-foreground mb-1">{card.value}</p>
            <p className="text-sm font-medium text-foreground mb-1">{card.title}</p>
            <p className="text-xs text-muted-foreground">{card.subtitle}</p>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default QuickActionCards;